import $ from "jquery";
import "jquery.scrollto";
import { ready } from "./utils.js";

ready(() => {
  const btndivein = document.getElementById("btndivein");

  function updateScrollClasses() {
    const scrollY = window.scrollY;
    if (scrollY > 200) {
      btndivein.classList.remove("visible");
    } else if (scrollY < 10) {
      btndivein.classList.add("visible");
    }
  }
  
  if (btndivein) {
    document.addEventListener("scroll", updateScrollClasses); //on scroll
    updateScrollClasses(); //after reload

    btndivein.addEventListener("click", function() {
        $(window).scrollTo(window.innerHeight, 1000);
    });
  }
});


/*
import { ready } from "./utils.js";

ready(() => {
  const header = document.getElementsByTagName("header")[0];

  function updateHeaderScrollClasses() {
    const scrollY = window.scrollY;
    if (scrollY > 150) {
      header.classList.add("small");
    } else if (scrollY < 10) {
      header.classList.remove("small");
    }
  }
  
  if (header) {
    document.addEventListener("scroll", updateHeaderScrollClasses); //on scroll
    //updateHeaderScrollClasses(); //after reload
  }
});
*/